import { DatePicker } from "antd";
import dayjs from "dayjs";
import React from "react";
import Error from "../Error";

const Datecomponenet = React.forwardRef((props, focus) => {
  const { index, ind, val, form, setForm, getFormdata } = props;

  /* const handleDate = (e, index, ind) => {
    let data = [...form];
    data[index].options[ind].form.value = e?.$d;

    setForm(data);
    getFormdata(data);
  }; */

  const handleDate = (e, index, ind) => {
    console.log("Selected Date:", e, index, ind);

    const selectedDate = new Date(e?.$d);
    const now = new Date();

    selectedDate.setHours(
      now.getHours(),
      now.getMinutes(),
      now.getSeconds(),
      now.getMilliseconds()
    );

    let data = [...form];
    data[index].options[ind].form.value = selectedDate;

    setForm(data);
    getFormdata(data);
  };

  const dateFormatList = ["DD/MM/YYYY", "DD-MM-YYYY"];

  return (
    <React.Fragment>
      <DatePicker
        format={dateFormatList}
        key={index?.toString()?.concat(ind)}
        id={index?.toString()?.concat(ind)}
        name={val?.form?.name}
        placeholder={val?.form?.placeholder}
        className={
          val?.form?.className ? val?.form?.className : "text-regular w-full"
        }
        ref={focus.current[val?.form?.name?.concat(index + "" + ind)]}
        size={val?.form?.size}
        value={val?.form?.value && dayjs(val?.form?.value)}
        onChange={(e) => handleDate(e, index, ind)}
        autoComplete="off"
        disabled={val?.form?.disabled ? val?.form?.disabled : false}
      />
      <Error id={val?.form?.name?.concat(index + "" + ind)} />
    </React.Fragment>
  );
});

export default Datecomponenet;
